import { Reducer } from 'react';
import { IActionPayload } from 'types';
import { WebsiteCreateState } from './state';

const reducer: Reducer<WebsiteCreateState, IActionPayload> = (
  state,
  action,
): WebsiteCreateState => {
  switch (action.type) {
    case 'SET_LOADING': {
      return {
        ...state,
        loading: action.payload,
      };
    }

    case 'SET_NOT_RECOMMENDED': {
      return {
        ...state,
        notRecommended: action.payload,
      };
    }

    case 'UPDATE_DATABASE':
    case 'UPDATE_DATABASE_FIELD':
    case 'UPDATE_DATABASE_VALUE': {
      return {
        ...state,
        database: action.payload,
      };
    }

    case 'UPDATE_WEBSITE':
    case 'UPDATE_WEBSITE_FIELD': {
      return {
        ...state,
        website: action.payload,
      };
    }

    case 'CREATE_WEBSITE_ERROR': {
      return {
        ...state,
        errors: action.payload,
      };
    }

    case 'CREATE_WEBSITE_DOMAIN': {
      return {
        ...state,
        website: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};

export default reducer;
